import { useDispatch } from "react-redux";

import { addSnackbar } from "actions/snackbar";
import { SnackbarContent } from "types/snackbar";

function useSnackbar() {
    const dispatch = useDispatch();

    return {
        addSnackbar: (params: SnackbarContent) => dispatch(addSnackbar(params)),
    };
}

export default useSnackbar;
